import React from 'react';
import { StepViewModel } from '../../models/step';
import { InputType } from '../../enums/input-type.enum';
import { ColorPickerViewRender } from '../../views/ColorPickerViewRender';
import { Option } from '../../models/option';
import { StepValues } from '../../models/step-values';
import { ProductHandle } from '../../../enums/ProductHandle.enum';
import { FinalSizeViewRender } from '../../views/FinalSizeViewRender';
import { Size } from '../../enums/size.enum';
import { SizeRange } from '../../models/size-range.model';
import { getMeasurementSizeFromWaistHips, RawSizeRange } from '../../utils/waist-hip-helper';

const sizes: Map<number, SizeRange[]> = new Map<number, SizeRange[]>();
sizes.set(25, [
  { size: Size.XS, lowerHipBound: 35, upperHipBound: 37 },
  { size: Size.S, lowerHipBound: 38, upperHipBound: 41 },
  { size: Size.M, lowerHipBound: 42, upperHipBound: 43 },
  { size: Size.L, lowerHipBound: 44, upperHipBound: 45 },
]);
sizes.set(26, [
  { size: Size.XS, lowerHipBound: 35, upperHipBound: 37 },
  { size: Size.S, lowerHipBound: 38, upperHipBound: 41 },
  { size: Size.M, lowerHipBound: 42, upperHipBound: 43 },
  { size: Size.L, lowerHipBound: 44, upperHipBound: 46 },
]);
sizes.set(27, [
  { size: Size.XS, lowerHipBound: 35, upperHipBound: 37 },
  { size: Size.S, lowerHipBound: 38, upperHipBound: 40 },
  { size: Size.M, lowerHipBound: 41, upperHipBound: 43 },
  { size: Size.L, lowerHipBound: 44, upperHipBound: 46 },
  { size: Size.XL, lowerHipBound: 47, upperHipBound: 47 },
]);
sizes.set(28, [
  { size: Size.XS, lowerHipBound: 35, upperHipBound: 36 },
  { size: Size.S, lowerHipBound: 37, upperHipBound: 40 },
  { size: Size.M, lowerHipBound: 41, upperHipBound: 42 },
  { size: Size.L, lowerHipBound: 43, upperHipBound: 46 },
  { size: Size.XL, lowerHipBound: 47, upperHipBound: 48 },
]);
sizes.set(29, [
  { size: Size.S, lowerHipBound: 35, upperHipBound: 39 },
  { size: Size.M, lowerHipBound: 40, upperHipBound: 42 },
  { size: Size.L, lowerHipBound: 43, upperHipBound: 45 },
  { size: Size.XL, lowerHipBound: 46, upperHipBound: 49 },
]);
sizes.set(30, [
  { size: Size.S, lowerHipBound: 35, upperHipBound: 39 },
  { size: Size.M, lowerHipBound: 40, upperHipBound: 42 },
  { size: Size.L, lowerHipBound: 43, upperHipBound: 45 },
  { size: Size.XL, lowerHipBound: 46, upperHipBound: 49 },
  { size: Size['1X'], lowerHipBound: 50, upperHipBound: 50 },
]);
sizes.set(31, [
  { size: Size.S, lowerHipBound: 35, upperHipBound: 35 },
  { size: Size.M, lowerHipBound: 36, upperHipBound: 42 },
  { size: Size.L, lowerHipBound: 43, upperHipBound: 45 },
  { size: Size.XL, lowerHipBound: 46, upperHipBound: 48 },
  { size: Size['1X'], lowerHipBound: 49, upperHipBound: 51 },
]);
sizes.set(32, [
  { size: Size.M, lowerHipBound: 35, upperHipBound: 42 },
  { size: Size.L, lowerHipBound: 43, upperHipBound: 45 },
  { size: Size.XL, lowerHipBound: 46, upperHipBound: 48 },
  { size: Size['1X'], lowerHipBound: 49, upperHipBound: 52 },
]);
sizes.set(33, [
  { size: Size.M, lowerHipBound: 35, upperHipBound: 42 },
  { size: Size.L, lowerHipBound: 43, upperHipBound: 45 },
  { size: Size.XL, lowerHipBound: 46, upperHipBound: 48 },
  { size: Size['1X'], lowerHipBound: 49, upperHipBound: 52 },
  { size: Size['2X'], lowerHipBound: 53, upperHipBound: 53 },
]);
sizes.set(34, [
  { size: Size.M, lowerHipBound: 36, upperHipBound: 40 },
  { size: Size.L, lowerHipBound: 41, upperHipBound: 45 },
  { size: Size.XL, lowerHipBound: 46, upperHipBound: 48 },
  { size: Size['1X'], lowerHipBound: 49, upperHipBound: 52 },
  { size: Size['2X'], lowerHipBound: 53, upperHipBound: 53 },
]);
sizes.set(35, [
  { size: Size.L, lowerHipBound: 37, upperHipBound: 45 },
  { size: Size.XL, lowerHipBound: 46, upperHipBound: 47 },
  { size: Size['1X'], lowerHipBound: 48, upperHipBound: 51 },
  { size: Size['2X'], lowerHipBound: 52, upperHipBound: 53 },
]);
sizes.set(36, [
  { size: Size.L, lowerHipBound: 37, upperHipBound: 45 },
  { size: Size.XL, lowerHipBound: 46, upperHipBound: 47 },
  { size: Size['1X'], lowerHipBound: 48, upperHipBound: 50 },
  { size: Size['2X'], lowerHipBound: 51, upperHipBound: 54 },
]);
sizes.set(37, [
  { size: Size.L, lowerHipBound: 38, upperHipBound: 42 },
  { size: Size.XL, lowerHipBound: 43, upperHipBound: 47 },
  { size: Size['1X'], lowerHipBound: 48, upperHipBound: 50 },
  { size: Size['2X'], lowerHipBound: 51, upperHipBound: 54 },
]);
sizes.set(38, [
  { size: Size.L, lowerHipBound: 38, upperHipBound: 42 },
  { size: Size.XL, lowerHipBound: 43, upperHipBound: 46 },
  { size: Size['1X'], lowerHipBound: 47, upperHipBound: 50 },
  { size: Size['2X'], lowerHipBound: 51, upperHipBound: 54 },
  { size: Size['3X'], lowerHipBound: 55, upperHipBound: 57 },
]);
sizes.set(39, [
  { size: Size.XL, lowerHipBound: 39, upperHipBound: 45 },
  { size: Size['1X'], lowerHipBound: 46, upperHipBound: 50 },
  { size: Size['2X'], lowerHipBound: 51, upperHipBound: 54 },
  { size: Size['3X'], lowerHipBound: 55, upperHipBound: 57 },
]);
sizes.set(40, [
  { size: Size.XL, lowerHipBound: 40, upperHipBound: 44 },
  { size: Size['1X'], lowerHipBound: 45, upperHipBound: 50 },
  { size: Size['2X'], lowerHipBound: 51, upperHipBound: 54 },
  { size: Size['3X'], lowerHipBound: 55, upperHipBound: 57 },
]);
sizes.set(41, [
  { size: Size['1X'], lowerHipBound: 41, upperHipBound: 50 },
  { size: Size['2X'], lowerHipBound: 51, upperHipBound: 54 },
  { size: Size['3X'], lowerHipBound: 55, upperHipBound: 58 },
]);
sizes.set(42, [
  { size: Size['1X'], lowerHipBound: 42, upperHipBound: 50 },
  { size: Size['2X'], lowerHipBound: 51, upperHipBound: 54 },
  { size: Size['3X'], lowerHipBound: 55, upperHipBound: 58 },
]);
sizes.set(43, [
  { size: Size['1X'], lowerHipBound: 43, upperHipBound: 49 },
  { size: Size['2X'], lowerHipBound: 50, upperHipBound: 54 },
  { size: Size['3X'], lowerHipBound: 55, upperHipBound: 58 },
]);
sizes.set(44, [
  { size: Size['2X'], lowerHipBound: 45, upperHipBound: 54 },
  { size: Size['3X'], lowerHipBound: 55, upperHipBound: 58 },
]);
sizes.set(45, [
  { size: Size['2X'], lowerHipBound: 45, upperHipBound: 53 },
  { size: Size['3X'], lowerHipBound: 54, upperHipBound: 57 },
]);
sizes.set(46, [
  { size: Size['2X'], lowerHipBound: 45, upperHipBound: 53 },
  { size: Size['3X'], lowerHipBound: 54, upperHipBound: 57 },
]);
sizes.set(47, [{ size: Size['3X'], lowerHipBound: 47, upperHipBound: 57 }]);
sizes.set(48, [{ size: Size['3X'], lowerHipBound: 47, upperHipBound: 57 }]);

export const calculateLeggingsSize = (waist = -1, hips = -1, pants = -1): Size => {
  const chartSize = getMeasurementSizeFromWaistHips(waist, hips, sizes);

  if (chartSize && chartSize !== Size['?']) {
    return chartSize;
  }

  switch (true) {
    case pants <= 2:
      return Size.XS;
    case pants <= 6:
      return Size.S;
    case pants <= 10:
      return Size.M;
    case pants <= 12:
      return Size.L;
    case pants <= 14:
      return Size.XL;
    case pants <= 16:
      return Size['1X'];
    case pants <= 20:
      return Size['2X'];
    case pants <= 24:
      return Size['3X'];
  }

  return Size['?'];
};

const getPossibleHipSizeFromWaist = (waistSize: number): RawSizeRange | null => {
  const waistSizes = waistSize > 48 ? sizes.get(48) : sizes.get(waistSize);

  if (!waistSizes || waistSizes.length === 0) {
    return null;
  }

  const ret = {
    lowerHipBound: waistSizes[0].lowerHipBound,
    upperHipBound: waistSizes[0].upperHipBound,
  };

  if (waistSizes.length > 0) {
    ret.upperHipBound = waistSizes[waistSizes.length - 1].upperHipBound;
  }

  return ret;
};

export const LeggingsSteps: StepViewModel[] = [
  {
    key: 'do-you-have-a-measuring-tape',
    text: 'Do you have a measuring tape?',
    progress: 0,
    options: [
      {
        text: 'Yes',
        nextStepKey: 'waist-instructions',
      },
      {
        text: 'No',
        nextStepKey: 'pants',
      },
    ],
  },
  {
    key: 'waist-instructions',
    text: 'Please measure your waist as shown below:',
    subText:
      'Waist measurements should be taken at the natural waist, the smallest point of the torso. It is usually a few inches below your bust, and a couple inches above your belly button.',
    image: 'measure-waist.svg',
    options: [
      {
        text: 'CONTINUE',
        inputType: InputType.CTAButton,
        nextStepKey: 'waist-measurement',
      },
    ],
  },
  {
    key: 'waist-measurement',
    text: 'What is your waist measurement?',
    options: [
      {
        imperialText: '25" or lower',
        metricText: '64 cm or lower',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '26"',
        metricText: '66 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '27"',
        metricText: '69 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '28"',
        metricText: '71 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '29"',
        metricText: '74 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '30"',
        metricText: '76 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '31"',
        metricText: '79 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '32"',
        metricText: '81 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '33"',
        metricText: '84 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '34"',
        metricText: '86 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '35"',
        metricText: '89 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '36"',
        metricText: '91 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '37"',
        metricText: '94 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '38"',
        metricText: '97 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '39"',
        metricText: '99 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '40"',
        metricText: '102 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '41"',
        metricText: '104 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '42"',
        metricText: '107 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '43"',
        metricText: '109 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '44"',
        metricText: '112 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '45"',
        metricText: '114 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '46"',
        metricText: '117 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '47"',
        metricText: '119 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '48"',
        metricText: '122 cm',
        nextStepKey: 'hip-instructions',
      },
      {
        imperialText: '49"',
        metricText: '124 cm',
        nextStepKey: 'not-ready',
      },
      {
        imperialText: '50"',
        metricText: '127 cm',
        nextStepKey: 'not-ready',
      },
      {
        imperialText: '51"',
        metricText: '130 cm',
        nextStepKey: 'not-ready',
      },
      {
        imperialText: '52"',
        metricText: '132 cm',
        nextStepKey: 'not-ready',
      },
      {
        imperialText: '53" or above',
        metricText: '135 cm',
        nextStepKey: 'not-ready',
      },
    ],
  },
  {
    key: 'hip-instructions',
    text: 'Got it! Next, let’s take your hip measurement:',
    subText: 'Hip measurements should be taken at the fullest point around your hips or bum, the placement can vary from body to body.',
    image: 'measure-hip.svg',
    options: [
      {
        text: 'CONTINUE',
        inputType: InputType.CTAButton,
        nextStepKey: 'hip-measurement',
      },
    ],
  },
  {
    key: 'hip-measurement',
    text: 'What is your hip measurement?',
    filter: (option: Option, stepValues: StepValues, productHandle: ProductHandle): boolean => {
      // Todo: Could potentially cache results to speed this up
      const waistSizeResponse = stepValues.get('waist-measurement');
      if (!waistSizeResponse || !waistSizeResponse.value || !option || !option.imperialText) {
        return false;
      }
      const waistSize = parseInt(waistSizeResponse.value, 10);
      const potentialSizes = getPossibleHipSizeFromWaist(waistSize);
      if (!potentialSizes) {
        return false;
      }

      const optionSize = parseInt(option.imperialText, 10);
      if (optionSize >= potentialSizes.lowerHipBound && optionSize <= potentialSizes.upperHipBound) {
        return true;
      }

      return false;
    },
    options: [
      {
        imperialText: '35" or lower',
        metricText: '89 cm or lower',
        nextStepKey: 'pants',
      },
      {
        imperialText: '36"',
        metricText: '91 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '37"',
        metricText: '94 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '38"',
        metricText: '97 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '39"',
        metricText: '99 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '40"',
        metricText: '102 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '41"',
        metricText: '104 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '42"',
        metricText: '107 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '43"',
        metricText: '109 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '44"',
        metricText: '112 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '45"',
        metricText: '114 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '46"',
        metricText: '117 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '47"',
        metricText: '119 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '48"',
        metricText: '122 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '49"',
        metricText: '124 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '50"',
        metricText: '127 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '51"',
        metricText: '130 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '52"',
        metricText: '132 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '53"',
        metricText: '135 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '54"',
        metricText: '137 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '55"',
        metricText: '140 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '56"',
        metricText: '142 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '57"',
        metricText: '145 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '58"',
        metricText: '147 cm',
        nextStepKey: 'pants',
      },
      {
        imperialText: '59" or above',
        metricText: '150 cm or above',
        nextStepKey: 'not-ready',
      },
    ],
  },
  {
    key: 'pants',
    text: 'What is your pant size?',
    options: [
      {
        text: '0',
        nextStepKey: 'height',
      },
      {
        text: '2',
        nextStepKey: 'height',
      },
      {
        text: '4',
        nextStepKey: 'height',
      },
      {
        text: '6',
        nextStepKey: 'height',
      },
      {
        text: '8',
        nextStepKey: 'height',
      },
      {
        text: '10',
        nextStepKey: 'height',
      },
      {
        text: '12',
        nextStepKey: 'height',
      },
      {
        text: '14',
        nextStepKey: 'height',
      },
      {
        text: '16',
        nextStepKey: 'height',
      },
      {
        text: '18',
        nextStepKey: 'height',
      },
      {
        text: '20',
        nextStepKey: 'height',
      },
      {
        text: '22',
        nextStepKey: 'height',
      },
      {
        text: '24',
        nextStepKey: 'height',
      },
    ],
  },
  {
    key: 'height',
    text: 'How tall are you?',
    options: [
      {
        imperialText: '5\'0" or below',
        metricText: '150 cm or below',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'1"',
        metricText: '155 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'2"',
        metricText: '157 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'3"',
        metricText: '160 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'4"',
        metricText: '163 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'5"',
        metricText: '165 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'6"',
        metricText: '168 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'7"',
        metricText: '170 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'8"',
        metricText: '173 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'9"',
        metricText: '175 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'10"',
        metricText: '178 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'11"',
        metricText: '180 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '6\'0"',
        metricText: '183 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '6\'1"',
        metricText: '185 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '6\'2"',
        metricText: '188 cm or above',
        nextStepKey: 'results',
      },
    ],
  },
  {
    key: 'results',
    text: '[engine]',
    progress: 95,
    options: [
      {
        text: '',
        nextStepKey: 'pick-a-color',
      },
    ],
    render: (props, onChange) => {
      return <FinalSizeViewRender {...props} nextStepKey="pick-a-color" onChange={onChange} />;
    },
  },
  {
    key: 'pick-a-color',
    text: 'pick-a-color',
    progress: 100,
    options: [],
    render: (props, onChange) => {
      return <ColorPickerViewRender {...props} onChange={onChange} />;
    },
  },
  {
    key: 'not-ready',
    text: `Hey love,

Our design team is still working on the size 4X, and it's not available yet.

If you'd like to be notified as soon as our expanded sizes launch, please leave your email below.

Alternatively, you can order in size 3X - if that's not the right size, we have an excellent return policy :)`,
    progress: 99,
    options: [
      {
        inputType: InputType.Email,
        nextStepKey: 'results',
        klaviyoKey: 'klaviyo4x5xId',
      },
      {
        inputType: InputType.SecondaryCTAButton,
        nextStepKey: 'pick-a-color',
        text: 'ORDER IN SIZE 3X',
      },
    ],
  },
];
